import React from "react";
import "./about.css";

function About() {
  return (
    <div className="page-container about-page">
      {/* Hero */}
      <section className="about-hero">
        <span className="about-label">ABOUT VORTEX NETWORK</span>

        <h1>
          Welcome to <span>Vortex Network</span>
        </h1>

        <p className="about-intro">
          Vortex Network is a growing gaming community focused on creating
          immersive, interactive, and enjoyable experiences for players
          everywhere.
        </p>
      </section>

      {/* About */}
      <section className="about-section">
        <h2>Who We Are</h2>

        <p>
          Vortex Network is a gaming-focused network built around community,
          creativity, and innovation. We create and support gaming projects,
          custom experiences, addons, tools, and services designed to bring
          players together.
        </p>

        <p>
          From custom Minecraft experiences to community projects and future
          gaming services, we are constantly working on new ideas and
          improving what we already have.
        </p>
      </section>

      {/* Features */}
      <section className="about-features">
        <div className="about-card">
          <div className="about-icon">🎮</div>

          <h3>Gaming</h3>

          <p>
            Discover custom gaming experiences, addons, projects, and tools
            created for the community.
          </p>
        </div>

        <div className="about-card">
          <div className="about-icon">🌐</div>

          <h3>Community</h3>

          <p>
            Connect with other players, share experiences, and become part of
            the growing Vortex Network community.
          </p>
        </div>

        <div className="about-card">
          <div className="about-icon">🚀</div>

          <h3>Innovation</h3>

          <p>
            We are always working on new projects, features, and ideas to
            create better gaming experiences.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="about-mission">
        <span className="about-label">OUR MISSION</span>

        <h2>Built for Players. Made for the Community.</h2>

        <p>
          Our mission is to create a futuristic and interactive gaming
          experience where players can discover new content, connect with
          others, and enjoy everything Vortex Network has to offer.
        </p>

        <p>
          We want Vortex Network to be more than just a website. We want it to
          be a place where gaming projects, communities, and players come
          together.
        </p>
      </section>

      {/* Closing */}
      <section className="about-cta">
        <h2>Welcome to Vortex Network.</h2>

        <p>
          Explore our projects, join the community, and see what's coming next.
        </p>
      </section>
    </div>
  );
}

export default About;